module.exports = __webpack_public_path__ + "img/read_zhong.d0f0ce72.png";